import React from 'react';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { EastEndWay } from '../components/EastEndWay';
import { Services } from '../components/Services';
import { Reviews } from '../components/Reviews';
import { ShopExperience } from '../components/ShopExperience';
import { usePageMeta } from '../hooks/usePageMeta';
export function Home() {
  usePageMeta('Auto Repair in Oak Ridge, TN | East End Automotive Repair', 'East End Automotive Repair in Oak Ridge, TN: diagnostics, maintenance, electrical, engine, A/C, alignment, transmission and general repair. Call (865) 206-2279.');
  return <>
      <Hero data-id="element-588" data-mp="29ihpvraaofmv" />
      <TrustStrip data-id="element-589" data-mp="2dhqk0x98yfiy" />
      <EastEndWay data-id="element-590" data-mp="2di8dxn8fshnp" />
      <Services data-id="element-591" data-mp="2dirrysuyulwg" />
      <Reviews data-id="element-592" data-mp="2dj9z4kj62kj5" />
      <ShopExperience data-id="element-593" data-mp="2dfm6dnljq25h" />
    </>;
}